<script>
import RequestListWrapper from '../components/RequestListWrapper';

export default {
    name: 'Draft',
    extends: RequestListWrapper,
    data() {
        return {
            status: 'Черновик'
        };
    },
    watch: {},
    computed: {},
    methods: {},
    mounted() {}
};
</script>
